// extracted by mini-css-extract-plugin
export default {"form-content":"FormContent_form-content__hK14-"};